<template>
  <div class="redsys">
    <RedsysRedirectionButton
      @pay="startRedsysPayment"
      ref="redsysRedirectionButtonRef"
      :amount="totalPrice"
      :disable="disablePaymentButton"
      :selectedCard="selectedPaymentMethod"
    ></RedsysRedirectionButton>

    <Loader
      :dialog-loader="dialogLoader"
      :message="$t('payment.redirectingToThePaymentprocess')"
    ></Loader>
  </div>
</template>

<script>
const NO_QR = "NO QR";
import Loader from "@/components/common/Loader";
import RedsysMixin from "@/mixins/payment/RedsysMixin";
import RedsysRedirectionButton from "@/components/public/payment/redsys/RedsysRedirectButton.vue";

export default {
  name: "RedsysPayment",
  mixins: [RedsysMixin],
  props: [
    "totalPrice",
    "disablePaymentButton",
    "canBeDirectPayment",
    "tableQR",
    "unpaidTotalPrice",
    "dividePayment",
    "selectedPaymentMethod"
  ],
  components: {
    Loader,
    RedsysRedirectionButton
  },
  data() {
    return {
      loading: false,
      dialog: false,
      dialogLoader: false,
      paymentType: "products",
      paymentMethod: "redsys"
    };
  },
  methods: {
    startRedsysPayment() {
      // check cart item length is greater then 20
      if (!this.tableQR || this.tableQR === NO_QR) {
        this.checkQR = true;
        this.$emit("checkQRUpdate", this.checkQR);
        return;
      }
      this.$refs.redsysRedirectionButtonRef.pay();
    }
  }
};
</script>
<style scoped lang="scss">
form#challangeForm {
  display: inline-block;
}

.card-design {
  padding: 0 0 0 10px;
}
</style>
